
import { DestineraArbetsorderHandelssortimentBaseCommand } from "~app/features/planera/commands/DestineraArbetsorderHandelssortimentBaseCommand";
import { ProduktionsmallBaseCommand } from "~app/features/planera/commands/ProduktionsmallBaseCommand";
import { ProduktionsmallHandelssortimentBaseCommand } from "~app/features/planera/commands/ProduktionsmallHandelssortimentBaseCommand";
import { ProduktionsmallProduktBaseCommand } from "~app/features/planera/commands/ProduktionsmallProduktBaseCommand";
import { ProduktionsmallProduktinstruktionBaseCommand } from "~app/features/planera/commands/ProduktionsmallProduktinstruktionBaseCommand";
import { ChangeLeveransplanPeriodCommand } from "~app/features/virkeskop/commands/Leveransplan/ChangeLeveransplanPeriodCommand";
import { LeveransplanCommandBase } from "~app/features/virkeskop/commands/Leveransplan/LeveransplanCommandBase";
import { AvverkningsanmalanCommandBase } from "~app/features/virkeskop/commands/atgard-avverkningsanmalan/AvverkningsanmalanCommandBase";
import { AtgardLeveransvirkesVolymCommandBase } from "~app/features/virkeskop/commands/atgard-leveransvirkesvolym/AtgardLeveransvirkesVolymCommandBase";
import { AnmalanTradslagBaseCommand } from "~app/features/virkeskop/commands/atgard-mbf/AnmalanTradslagBaseCommand";
import { AtgardNaturvardesbedomningCommandBase } from "~app/features/virkeskop/commands/atgard-nvb/AtgardNaturvardesbedomningCommandBase";
import { AtgardBaseCommand } from "~app/features/virkeskop/commands/atgard/AtgardBaseCommand";
import { AvtalCommandBase } from "~app/features/virkeskop/commands/avtal/AvtalCommandBase";
import { CreateAvverkningskostnaderCommand } from "~app/features/virkeskop/commands/avverkningskostnader/CreateAvverkningskostnaderCommand";
import { UpdateKontraktBetalningarCommand } from "~app/features/virkeskop/commands/betalning/UpdateKontraktBetalningarCommand";
import { UpdateKontraktCertifikatCommand } from "~app/features/virkeskop/commands/certifikat/UpdateKontraktCertifikatCommand";
import { GeometryBaseCommand } from "~app/features/virkeskop/commands/karta/GeometryBaseCommand";
import { AtgardKedjaBaseCommand } from "~app/features/virkeskop/commands/kedjakoppling/AtgardKedjaBaseCommand";
import { KontraktCommandBase } from "~app/features/virkeskop/commands/kontrakt/KontraktCommandBase";
import { LeverantorCommandBase } from "~app/features/virkeskop/commands/leverantorer/LeverantorCommandBase";
import { UpdateBetalningSkogsvardCommand } from "~app/features/virkeskop/commands/skogsvard-betalning/UpdateBetalningSkogsvardCommand";
import { UpdateSkogsvardTradskiktCommand } from "~app/features/virkeskop/commands/skogsvard-tradskikt/UpdateSkogsvardTradskiktCommand";
import { SkogsvardTradslagBaseCommand } from "~app/features/virkeskop/commands/skogsvard-tradslag/SkogsvardTradslagBaseCommand";
import { UpdateDirektutbyteCommand } from "~app/features/virkeskop/commands/tradslag/UpdateDirektutbyteCommand";
import { UpdateSnabbkalkylCommand } from "~app/features/virkeskop/commands/tradslag/UpdateSnabbkalkylCommand";
import { UpdateKontraktUtskriftCommand } from "~app/features/virkeskop/commands/utskrift/UpdateKontraktUtskriftCommand";
import { VirkeskostnadBaseCommand } from "~app/features/virkeskop/commands/virkeskostnader/VirkeskostnadBaseCommand";
import { ArbetsorderHandelssortimentBaseCommand } from "../../../../app/features/planera/commands/ArbetsorderHandelssortimentBaseCommand";
import { ArbetsorderProduktBaseCommand } from "../../../../app/features/planera/commands/ArbetsorderProduktBaseCommand";
import { ArbetsorderProduktinstruktionBaseCommand } from "../../../../app/features/planera/commands/ArbetsorderProduktinstruktionBaseCommand";
import { UpdateArbetsorderProduktsattCommand } from "../../../../app/features/planera/commands/UpdateArbetsorderProduktsattCommand";
import { DependencyContext } from "./DependencyContext";
import { DependencyRuleBuilder } from "./DependencyRuleBuilder";
import { DependencyType } from "./DependencyType";
import { OnDeleteOption } from "./OnDeleteOption";
export class DependencyGraph {
// eslint-disable-next-line sonarjs/public-static-readonly
    static isInitialized = false;
    static init() {
        if (!this.isInitialized) {
            DependencyContext.entityHasRule<ArbetsorderHandelssortimentBaseCommand, ArbetsorderProduktBaseCommand>(
                ArbetsorderHandelssortimentBaseCommand.$groupKey,
                new DependencyRuleBuilder<ArbetsorderHandelssortimentBaseCommand, ArbetsorderProduktBaseCommand>()
                    .withPrincipal(ArbetsorderHandelssortimentBaseCommand.$groupKey)
                    .withDependent(ArbetsorderProduktBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<ArbetsorderProduktBaseCommand, ArbetsorderProduktinstruktionBaseCommand>(
                ArbetsorderProduktBaseCommand.$groupKey,
                new DependencyRuleBuilder<ArbetsorderProduktBaseCommand, ArbetsorderProduktinstruktionBaseCommand>()
                    .withPrincipal(ArbetsorderProduktBaseCommand.$groupKey)
                    .withDependent(ArbetsorderProduktinstruktionBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<ArbetsorderProduktinstruktionBaseCommand, DestineraArbetsorderHandelssortimentBaseCommand>(
                ArbetsorderProduktinstruktionBaseCommand.$groupKey,
                new DependencyRuleBuilder<ArbetsorderProduktinstruktionBaseCommand, DestineraArbetsorderHandelssortimentBaseCommand>()
                    .withPrincipal(ArbetsorderProduktinstruktionBaseCommand.$groupKey)
                    .withDependent(DestineraArbetsorderHandelssortimentBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<UpdateArbetsorderProduktsattCommand, ArbetsorderHandelssortimentBaseCommand>(
                ArbetsorderHandelssortimentBaseCommand.$groupKey,
                new DependencyRuleBuilder<UpdateArbetsorderProduktsattCommand, ArbetsorderHandelssortimentBaseCommand>()
                    .withPrincipal(UpdateArbetsorderProduktsattCommand.$groupKey)
                    .withDependent(ArbetsorderHandelssortimentBaseCommand.$groupKey)
                    .withType(DependencyType.PrincipalAlwaysLast)
                    .build());

            DependencyContext.entityHasRule<ProduktionsmallBaseCommand, ProduktionsmallHandelssortimentBaseCommand>(
                ProduktionsmallBaseCommand.$groupKey,
                new DependencyRuleBuilder<ProduktionsmallBaseCommand, ProduktionsmallProduktBaseCommand>()
                    .withPrincipal(ProduktionsmallBaseCommand.$groupKey)
                    .withDependent(ProduktionsmallHandelssortimentBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<ProduktionsmallHandelssortimentBaseCommand, ProduktionsmallProduktBaseCommand>(
                ProduktionsmallHandelssortimentBaseCommand.$groupKey,
                new DependencyRuleBuilder<ProduktionsmallHandelssortimentBaseCommand, ProduktionsmallProduktBaseCommand>()
                    .withPrincipal(ProduktionsmallHandelssortimentBaseCommand.$groupKey)
                    .withDependent(ProduktionsmallProduktBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<ProduktionsmallProduktBaseCommand, ProduktionsmallProduktinstruktionBaseCommand>(
                ProduktionsmallProduktBaseCommand.$groupKey,
                new DependencyRuleBuilder<ProduktionsmallProduktBaseCommand, ProduktionsmallProduktinstruktionBaseCommand>()
                    .withPrincipal(ProduktionsmallProduktBaseCommand.$groupKey)
                    .withDependent(ProduktionsmallProduktinstruktionBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<AvtalCommandBase, LeverantorCommandBase>(
                AvtalCommandBase.$groupKey,
                new DependencyRuleBuilder<AvtalCommandBase, LeverantorCommandBase>()
                    .withPrincipal(AvtalCommandBase.$groupKey)
                    .withDependent(LeverantorCommandBase.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<AvtalCommandBase, KontraktCommandBase>(
                AvtalCommandBase.$groupKey,
                new DependencyRuleBuilder<AvtalCommandBase, KontraktCommandBase>()
                    .withPrincipal(AvtalCommandBase.$groupKey)
                    .withDependent(KontraktCommandBase.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, AtgardBaseCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, AtgardBaseCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(AtgardBaseCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, UpdateKontraktBetalningarCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, UpdateKontraktBetalningarCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(UpdateKontraktBetalningarCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, UpdateBetalningSkogsvardCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, UpdateBetalningSkogsvardCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(UpdateBetalningSkogsvardCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, UpdateKontraktCertifikatCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, UpdateKontraktCertifikatCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(UpdateKontraktCertifikatCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, ChangeLeveransplanPeriodCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, ChangeLeveransplanPeriodCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(ChangeLeveransplanPeriodCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<KontraktCommandBase, UpdateKontraktUtskriftCommand>(
                KontraktCommandBase.$groupKey,
                new DependencyRuleBuilder<KontraktCommandBase, UpdateKontraktUtskriftCommand>()
                    .withPrincipal(KontraktCommandBase.$groupKey, x => x.kontraktGuid)
                    .withDependent(UpdateKontraktUtskriftCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, GeometryBaseCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, GeometryBaseCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey)
                    .withDependent(GeometryBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, AvverkningsanmalanCommandBase>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, AvverkningsanmalanCommandBase>()
                    .withPrincipal(AtgardBaseCommand.$groupKey)
                    .withDependent(AvverkningsanmalanCommandBase.$groupKey)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<VirkeskostnadBaseCommand, AtgardLeveransvirkesVolymCommandBase>(
                VirkeskostnadBaseCommand.$groupKey,
                new DependencyRuleBuilder<VirkeskostnadBaseCommand, AtgardLeveransvirkesVolymCommandBase>()
                    .withPrincipal(VirkeskostnadBaseCommand.$groupKey)
                    .withDependent(AtgardLeveransvirkesVolymCommandBase.$groupKey)
                    .withType(DependencyType.Child)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, CreateAvverkningskostnaderCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, CreateAvverkningskostnaderCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(CreateAvverkningskostnaderCommand.$groupKey, x => x.virkeskopsatgardGUID)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, VirkeskostnadBaseCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, VirkeskostnadBaseCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey)
                    .withDependent(VirkeskostnadBaseCommand.$groupKey)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, AtgardLeveransvirkesVolymCommandBase>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, AtgardLeveransvirkesVolymCommandBase>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(AtgardLeveransvirkesVolymCommandBase.$groupKey, x => x.leveransvirkesvolym.virkeskopsatgardLeveransvirkeGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, AtgardNaturvardesbedomningCommandBase>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, AtgardNaturvardesbedomningCommandBase>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(AtgardNaturvardesbedomningCommandBase.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, AnmalanTradslagBaseCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, AnmalanTradslagBaseCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(AnmalanTradslagBaseCommand.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<VirkeskostnadBaseCommand, LeveransplanCommandBase>(
                VirkeskostnadBaseCommand.$groupKey,
                new DependencyRuleBuilder<VirkeskostnadBaseCommand, LeveransplanCommandBase>()
                    .withPrincipal(VirkeskostnadBaseCommand.$groupKey, x => x.guid)
                    .withDependent(LeveransplanCommandBase.$groupKey, x => x.virkeskostnadGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, UpdateSnabbkalkylCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, UpdateSnabbkalkylCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(UpdateSnabbkalkylCommand.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, UpdateDirektutbyteCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, UpdateDirektutbyteCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(UpdateDirektutbyteCommand.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, SkogsvardTradslagBaseCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, SkogsvardTradslagBaseCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(SkogsvardTradslagBaseCommand.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, UpdateSkogsvardTradskiktCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, UpdateSkogsvardTradskiktCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.atgardGuid)
                    .withDependent(UpdateSkogsvardTradskiktCommand.$groupKey, x => x.atgardGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            DependencyContext.entityHasRule<AtgardBaseCommand, AtgardKedjaBaseCommand>(
                AtgardBaseCommand.$groupKey,
                new DependencyRuleBuilder<AtgardBaseCommand, AtgardKedjaBaseCommand>()
                    .withPrincipal(AtgardBaseCommand.$groupKey, x => x.kontraktGuid)
                    .withDependent(AtgardKedjaBaseCommand.$groupKey, x => x.kontraktGuid)
                    .withType(DependencyType.Child)
                    .onDelete(OnDeleteOption.cascade)
                    .build());

            this.isInitialized = true;
        }
    }
}
